// extracted by mini-css-extract-plugin
export default {"black":"BlackBtn_black__U-SWa"};